import { Controller } from '@hotwired/stimulus';
import L from "leaflet";
import "leaflet/dist/leaflet.css";

export default class extends Controller {
  static values = {
    features: Object,
    markers: Array,
    center:  Object,
    zoom:    Number,
    enableSdk: Boolean,
    zoomControl: {
      type: Boolean,
      default: true
    },
    attributionControl: {
      type: Boolean,
      default: true
    }
  }

  connect() {
    this.markersGroup = [];

    this.settings = {
      tileLayer: {
        tiles:
          'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        subdomains: 'abcd',
      },
      dragging: window.width > 700,
      tap: window.width > 700,
    };

    this.initializeMap();

    this.updateMapFeatures();

    if (this.enableSdkValue) {
      this.initializeSdk();
    }
  }

  initializeMap() {
    this.map = L.map(this.element, {
      zoom: this.hasZoomValue ? this.zoomValue : 14,
      center: this.hasCenterValue ? this.centerValue : undefined,
      scrollWheelZoom: false,
      dragging: this.settings.dragging,
      tap: this.settings.tap,
      zoomControl: this.zoomControlValue,
      attributionControl: this.attributionControlValue
    });

    this.map.once('focus', () => {
      this.map.scrollWheelZoom.enable();
    });

    L.tileLayer(this.settings.tileLayer.tiles, {
      attribution: this.settings.tileLayer.attribution,
      minZoom: 1,
      maxZoom: 19,
    }).addTo(this.map);
  }

  updateMapFeatures() {
    this.featureGroup = L.featureGroup().addTo(this.map);

    if (this.hasMarkersValue && this.markersValue.length > 0) {
      this.markersValue.forEach(marker => {
         var marker = L.marker([marker.lat, marker.lng], {
          ...(marker.options || {}),
          icon: L.icon({ iconUrl: marker.icon })
        });

        this.featureGroup.addLayer(marker)
      })
    }

    if (this.hasFeaturesValue && this.featuresValue.features.length > 0) {
      var features = L.geoJSON(this.featuresValue, {
        style(geoJsonFeature) {
          return geoJsonFeature.properties.style;
        }
      })

      this.featureGroup.addLayer(features);
    }

    if (!this.hasZoomValue) this.map.fitBounds(this.featureGroup.getBounds());
  }

  initializeSdk() {
    if (!window.HQ) {
      setTimeout(this.initializeSdk.bind(this), 500);
      return;
    }

    const feature = this.featuresValue.features[0];
    const hood = feature.properties.slug;
    const city = feature.properties.city.slug;

    console.log('attempting to load map');

    HQ.waitFor('Map').then((Map) => {
      console.log('map loaded');
      this.hqMap = new Map({
        map: this.map,
        mapType: 'leaflet',
        mapOptions: {
          autoZoomAllMarkers: true,
        },
        disableFilters: true,
        defaultFilters: {
          schools: {
            type: ['public', 'catholic'],
            language: ['english'],
            grade_level: [],
            score: '',
          },
        },
        neighbourhood: { hood, city }
      });
    });
  }
}
